import styled from 'styled-components';
import { GREY_800, GREY_400 } from '../../constants';

export const SummaryItemContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    gap: 1rem;
`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex: 1;
`;

export const Value = styled.h1`
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
    text-align: left;
    white-space: nowrap;
    color: ${GREY_800};
    gap: 0.5rem;
    display: flex;
`;

export const Label = styled.p`
    margin-top: 0;
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem;
    text-align: left;
    white-space: nowrap;
    color: ${GREY_400};
`;

export const IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
`;
